export default "__VITE_ASSET__iQ25SetO__"